import { cn } from "@/lib/utils"

const labelClass = "text-xs uppercase tracking-wider text-muted-foreground"

interface FieldLabelProps {
  children: React.ReactNode
  className?: string
}

export function FieldLabel({ children, className }: FieldLabelProps) {
  return <div className={cn(labelClass, className)}>{children}</div>
}

export const sectionTitleClass = "text-xs uppercase tracking-wider text-muted-foreground font-medium"
